import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "section-row" }
const _hoisted_3 = { class: "section-copy" }
const _hoisted_4 = { class: "section-title mb-1" }
const _hoisted_5 = { class: "card-desc" }
const _hoisted_6 = { class: "section-status" }
const _hoisted_7 = { class: "section-title" }

import StatusInline from "@/shared/components/ui/StatusInline.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailPageHeader',
  props: {
    item: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.item.title.label), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.item.title.value || "-"), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(__props.item.status.label), 1),
        _createVNode(StatusInline, {
          status: __props.item.status.value
        }, null, 8, ["status"])
      ])
    ])
  ]))
}
}

})